import { STEP_TYPES } from "shared/consts";
import store from "src/store";
const keccak = require("keccak");

export function getByte32List() {
  let steps = store.steps;
  let byte32Variables = {};

  for (let i = 0; i < steps.length; i++) {
    let currentStep = steps[i];
    if (currentStep.type === STEP_TYPES.COMPILE_SMART_CONTRACT) {
      if (!currentStep.using_review_files) {
        byte32Variables = { ...byte32Variables, ...getByte32VariablesFromFiles(currentStep.files) };
      } else {
        byte32Variables = { ...byte32Variables, ...getByte32VariablesFromFiles(store.selectedReviewData.files) };
      }
    }
  }

  const uniqueByte32Variables = removeDuplicates(byte32Variables);
  return uniqueByte32Variables;
}

function getByte32VariablesFromFiles(files) {
  const keccak256Regex = /keccak256\(([^)]+)\)/g;
  const result = {};

  if(files && files.length) {
    files.forEach((file) => {
      const { content } = file;
      let match;
      while ((match = keccak256Regex.exec(content)) !== null) {
        const variableName = match[1].trim().replace(/['"]/g, ""); // Remove quotes if present
        const hash = "0x" + keccak("keccak256").update(Buffer.from(variableName, "utf-8")).digest("hex");
        result[hash] = variableName;
      }
    });
  }

  return result;
}

function removeDuplicates(byte32Variables) {
  const uniqueVariables = {};

  for (const [key, value] of Object.entries(byte32Variables)) {
    if (!uniqueVariables[key]) {
      uniqueVariables[key] = value;
    }
  }

  return uniqueVariables;
}
